export default __webpack_public_path__ + "static/media/TVs.6792ca4e.png";